import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationConstants } from '../../providers/application-constants';
import { TravelerComponent } from '../traveler/traveler.component';


@Component({
  selector: 'app-traveler-check',
  templateUrl: './traveler-check.component.html',
  styleUrls: ['./traveler-check.component.css']
})
export class TravelerCheckComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<TravelerCheckComponent>, public dialog: MatDialog,
    private applicationConstants: ApplicationConstants, public translate: TranslateService) {
    this.getMessages(translate);
  }

  addDialogRef: MatDialogRef<TravelerComponent>;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }


  ngOnInit() {
  }

  newTraveler() {
    this.close();
    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        
      });
      
  }

  close() {
    this.dialogRef.close();
  }

}
